<template>
    <b-modal id="createModal" ref="modal" title="Create an Association" v-model="show" @ok="handleSubmit" @hide="close" @shown="focusNameInput">

        <div class="form-group">
            <label>Association Name</label>
            <div class="position-relative">
                <input type="text" ref="nameInput" name="name" v-validate="{required: true}" class="form-control" v-model="name">
                <div class="invalid-feedback" v-if="errors.has('name')">{{ errors.first('name') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <div class="form-group">
            <label>Managed Crop Type</label>
            <div class="position-relative">
                <vue-select :options="cropTypes" track-by="id" label="name" v-model="cropType" />
                <div class="invalid-feedback" v-if="errors.has('cropType')">{{ errors.first('cropType') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <template slot="modal-footer">
            <button class="btn btn-secondary" @click="close">
                Cancel
            </button>
            <button class="btn btn-primary" :disabled="okDisabled" @click="handleSubmit">
                Save
            </button>
        </template>
    </b-modal>
</template>


<script>
import listAssociationsQuery from '@views/Associations/Browse/queryListAssociations.graphql';
import createAssociationMutation from '@views/Associations/CreateModal/mutationCreateAssociation.graphql';
import listCropTypesQuery from '@views/Associations/CreateModal/queryListCropTypes.graphql';

export default {
  name: 'create-modal',
  apollo: {
    allCropTypes: {
      query: listCropTypesQuery,
      update: data => {
        return data.filterCropTypes.data;
      },
      variables() {
        return {
          input: {
            limit: 1000,
          },
        };
      },
    },
  },
  props: {
    close: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      name: '',
      cropType: null,
      show: true,
      allCropTypes: [],
      loading: 0,
    };
  },
  computed: {
    cropTypes() {
      return this.allCropTypes
        .filter(cropType => !cropType.association)
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    okDisabled() {
      return this.name.length === 0;
    },
  },
  methods: {
    handleSubmit() {
      if (this.okDisabled) {
        return false;
      }
      this.errors.remove('global');
      this.$validator.validateAll().then(validationWasSuccessful => {
        if (!validationWasSuccessful) {
          return;
        }

        const input = { name: this.name };
        if (this.cropType) {
          input.crop_type_id = this.cropType.id;
        }

        this.$apollo
          .mutate({
            mutation: createAssociationMutation,
            refetchQueries: [
              { query: listAssociationsQuery },
              { query: listAssociationsQuery, variables: { input: { include_deleted: true } } },
            ],
            variables: {
              input,
            },
          })
          .then(() => {
            this.$notifySuccess('Association created!');
            this.close();
          })
          .catch(err => {
            this.$mapGraphQLError(err);
          })
          .catch(err => {
            console.error(err);
            this.$notifyFailure(
              'Unfortunately, we were unable to do that!',
            );
          });
      });
    },
    focusNameInput() {
      this.$refs.nameInput.focus();
    },
  },
};
</script>
